<template>
  <div style="height: 100%;background-color: #fbfbfb;padding: 20px;box-sizing: border-box;display: flex">
    <div class="menu-left">
      <div class="title-menu">
        <div class="left-bg"></div>
        <div :style="{color: val === 1 ? '#4578F6' : ''}" class="menu-text" @click="val = 1">早餐</div>
        <div :style="{color: val === 2 ? '#4578F6' : ''}" class="menu-text" @click="val = 2">午餐</div>
        <div :style="{color: val === 3 ? '#4578F6' : ''}" class="menu-text" @click="val = 3">晚餐</div>
      </div>
      <div class="menu-list">
        <div class="flex-container">
          <div class="flex-item" v-for="(item, index) in menuList" :key="index">
            <div :class="getBG(item)" class="item" @click="selItem(item)">
              <div class="img-top"><img :src="item.url"/></div>
              <div style="display: flex;height: 40px;color: #3D3D3D;">
                <div style="flex: 1;">{{ item.name }}</div>
                <div style="width: 60px;text-align: right">￥{{ item.val }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="person-right">
      <div class="person-right1">
        <div class="person-top-img"><img v-if="url !== ''" style="width: 153px;height: 153px" :src="url" /><img v-else style="width: 153px;height: 153px" src="/static/testmenu/xqy.png" /></div>
        <div style="height: 50px;line-height: 50px;font-size: 20px;color: #3D3D3D;text-align: center">{{ name }}</div>
        <div style="height: calc(100% - 320px);overflow-y: auto;">
          <div v-if="selectArr.length !== 0">
            <el-row style="color: #3D3D3D;font-size: 20px;">
              <el-col :span="8">菜品</el-col>
              <el-col :span="8" style="text-align: center">数量</el-col>
              <el-col :span="8" style="text-align: right">价格</el-col>
            </el-row>
            <el-row style="color: #3D3D3D;font-size: 16px;margin-top: 15px" v-for="(item, index) in selectArr" :key="index">
              <el-col :span="8"><div class="div-text">{{ item.name }}</div></el-col>
              <el-col :span="8" style="text-align: center">
                <div class="num-box">
                  <div class="bg-color" @click="minus(index)">-</div>
                  <div class="nun-center">{{item.num}}</div>
                  <div class="bg-color" @click="add(index)">+</div>
                </div>
              </el-col>
              <el-col :span="8" style="text-align: right"><div class="div-text">￥{{item.price}}</div></el-col>
            </el-row>
          </div>
        </div>
        <div v-if="selectArr.length !== 0" class="btn-send" @click="send">确认取餐</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'cashierDesk',
  data () {
    return {
      val: 1,
      menuList: [
        {name: '白米饭', val: 2, url: '/static/testmenu/1.png'},
        {name: '白灼菜', val: 8, url: '/static/testmenu/2.png'},
        {name: '手撕包菜', val: 10, url: '/static/testmenu/3.png'},
        {name: '酸辣土豆丝', val: 10, url: '/static/testmenu/4.png'},
        {name: '蚝油生菜', val: 15, url: '/static/testmenu/5.png'},
        {name: '西红柿炒蛋', val: 12, url: '/static/testmenu/6.png'},
        {name: '麻婆豆腐', val: 12, url: '/static/testmenu/7.png'},
        {name: '腊肉', val: 15, url: '/static/testmenu/8.png'},
        {name: '清蒸鱼', val: 15, url: '/static/testmenu/9.png'},
        {name: '爆炒茄子', val: 15, url: '/static/testmenu/10.png'},
        {name: '辣椒炒肉', val: 15, url: '/static/testmenu/11.png'},
        {name: '红烧肉', val: 15, url: '/static/testmenu/12.png'},
        {name: '黄焖鸡', val: 15, url: '/static/testmenu/13.png'},
        {name: '青椒肉丝', val: 15, url: '/static/testmenu/14.png'},
        {name: '水煮肉片', val: 15, url: '/static/testmenu/15.png'}
      ],
      selectArr: [],
      name: '',
      url: ''
    }
  },
  created () {
    this.golobleObject.updateTableAlarm = this.mqttPerson
  },
  methods: {
    getBG (item) {
      let flag = false
      this.selectArr.forEach(val => {
        if (item.name === val.name) {
          flag = true
        }
      })
      if (flag) {
        return 'item1'
      }
    },
    selItem (item) {
      if (this.name === '') {
        return
      }
      let flag = true
      for (let i = 0; i < this.selectArr.length; i++) {
        if (this.selectArr[i].name === item.name) {
          this.selectArr[i].num += 1
          this.selectArr[i].price = item.val * this.selectArr[i].num
          flag = false
        }
      }
      if (flag) {
        let obj = {
          name: item.name,
          num: 1,
          price: item.val,
          val: item.val
        }
        this.selectArr.push(obj)
      }
    },
    minus (index) {
      let num = this.selectArr[index].num - 1
      if (num === 0) {
        this.selectArr = this.selectArr.filter((item, i) => i !== index)
      } else {
        this.selectArr[index].num = num
      }
    },
    add (index) {
      this.selectArr[index].num = this.selectArr[index].num + 1
      this.selectArr[index].price = this.selectArr[index].val * this.selectArr[index].num
    },
    send () {
      this.$message.success('取餐成功')
      this.name = ''
      this.url = ''
      this.selectArr = []
    },
    mqttPerson (obj) {
      this.name = obj.name
      this.url = obj.image
      this.selectArr = [
        {name: '白米饭', num: 1, price: 2, val: 2},
        {name: '爆炒茄子', num: 1, price: 15, val: 15},
        {name: '腊肉', num: 1, price: 15, val: 15},
        {name: '黄焖鸡', num: 1, price: 15, val: 15}
      ]
    }
  }
}
</script>

<style scoped>
.menu-left{
  width: 70%;
  height: 100%;
  background: #FFFFFF;
  box-shadow: 0px 4px 13px 0px rgba(0,0,0,0.12);
  border-radius: 10px 10px 10px 10px;
  padding: 20px;
  box-sizing: border-box;
}
.person-right{
  flex: 1;
  height: 100%;
}
.person-right1{
  padding: 20px;
  box-sizing: border-box;
  margin-left: 20px;
  height: 100%;
  background: #FFFFFF;
  box-shadow: 0px 4px 13px 0px rgba(0,0,0,0.12);
  border-radius: 10px 10px 10px 10px;
}
.title-menu{
  height: 53px;
  background: rgba(19,115,214,0.08);
  border-radius: 3px 3px 3px 3px;
  display: flex;
}
.left-bg{
  width: 6px;
  height: 53px;
  background: #1373D6;
  border-radius: 6px 6px 6px 6px;
}
.menu-text{
  height: 53px;
  line-height: 53px;
  width: 100px;
  text-align: center;
  cursor: pointer;
  color: #3D3D3D;
  font-size: 18px;
}
.menu-list{
  height: calc(100% - 73px);
  overflow-y: auto;
  margin-top: 20px;
}

.flex-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around; /* 可选的，用于在行内均匀分布元素 */
}

.flex-item {
  width: 20%; /* 每个元素占一行的20%宽度 */
}
.item {
  cursor: pointer;
  margin: 20px auto 0;
  width: 186px;
  height: 200px;
  box-sizing: border-box; /* 确保边框和内边距包含在宽度内 */
  padding: 10px; /* 可选的内边距 */
  background: #FFFFFF;
  box-shadow: 0px 4px 10px 0px rgba(0,0,0,0.11);
  border-radius: 6px 6px 6px 6px;
}
.item1{
  border: 1px solid #1373D6;
}
.img-top{
  width: 100%;
  height: 150px;
  margin: auto;
  overflow: hidden;
}
.img-top img{
  width: 150px;
  vertical-align: middle;
}
.person-top-img{
  height: 170px;
  text-align: center;
}
.div-text{
  height: 40px;
  line-height: 40px;
}
.num-box{
  margin: auto;
  width: 140px;
  height: 40px;
  background: rgba(19,115,214,0.07);
  border-radius: 20px 20px 20px 20px;
  display: flex;
}
.bg-color{
  width: 40px;
  height: 40px;
  background: #1373D6;
  border-radius: 20px 20px 20px 20px;
  font-size: 20px;
  line-height: 40px;
  text-align: center;
  color: #FFFFFF;
}
.nun-center{
  line-height: 40px;
  text-align: center;
  color: #3D3D3D;
  flex: 1;
}
.btn-send{
  width: 250px;
  height: 70px;
  line-height: 70px;
  color: #FFFFFF;
  text-align: center;
  background: #1373D6;
  border-radius: 35px;
  font-weight: 500;
  font-size: 30px;
  cursor: pointer;
  margin: 20px auto;
}
</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/cashierDesk.vue